// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__l-htB","checkboxCol":"Table_checkboxCol__36JMm","emailCol":"Table_emailCol__1wFmB","actionCol":"Table_actionCol__10sF6"};